import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function getUser() {
  try { return JSON.parse(localStorage.getItem('candidateUser')); } catch { return null; }
}

export default function CandidateDashboard() {
  const navigate = useNavigate();
  const [user] = useState(getUser);
  const [view, setView] = useState('overview');

  useEffect(() => {
    if (!localStorage.getItem('candidateToken') || !user) {
      navigate('/login');
    }
  }, [user, navigate]);

  const logout = () => {
    localStorage.removeItem('candidateToken');
    localStorage.removeItem('candidateUser');
    navigate('/login');
  };

  if (!user) return null;

  return (
    <div style={s.layout}>
      {/* Sidebar */}
      <aside style={s.sidebar}>
        <div style={s.sidebarHeader}>
          <div style={s.logo}>H</div>
          <div>
            <div style={s.brandName}>My Dashboard</div>
            <div style={s.brandSub}>CANDIDATE</div>
          </div>
        </div>
        
        <nav style={s.nav}>
          <button onClick={() => setView('overview')} style={{ ...s.navBtn, ...(view === 'overview' ? s.navBtnActive : {}) }}>
            📊 Overview
          </button>
          <button onClick={() => setView('applications')} style={{ ...s.navBtn, ...(view === 'applications' ? s.navBtnActive : {}) }}>
            📋 My Applications
          </button>
          <button onClick={() => setView('saved')} style={{ ...s.navBtn, ...(view === 'saved' ? s.navBtnActive : {}) }}>
            💾 Saved Jobs
          </button>
          <button onClick={() => setView('profile')} style={{ ...s.navBtn, ...(view === 'profile' ? s.navBtnActive : {}) }}>
            👤 My Profile
          </button>
          <button onClick={() => setView('jobs')} style={{ ...s.navBtn, ...(view === 'jobs' ? s.navBtnActive : {}) }}>
            🔍 Browse Jobs
          </button>
        </nav>
        
        <div style={s.sidebarFooter}>
          <div style={{ fontSize: '13px', color: '#94a3b8', marginBottom: '10px' }}>
            {user.firstName} {user.lastName}
          </div>
          <button onClick={logout} style={s.logoutBtn}>Sign Out</button>
        </div>
      </aside>

      {/* Main Content */}
      <main style={s.main}>
        {view === 'overview' && <OverviewView user={user} setView={setView} />}
        {view === 'applications' && <ApplicationsView user={user} />}
        {view === 'saved' && <SavedJobsView user={user} />}
        {view === 'profile' && <ProfileView user={user} />}
        {view === 'jobs' && <JobsView user={user} />}
      </main>
    </div>
  );
}

// ============================== OVERVIEW VIEW ==============================
function OverviewView({ user, setView }) {
  const [stats, setStats] = useState({ total: 0, reviewing: 0, shortlisted: 0, saved: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    const token = localStorage.getItem('candidateToken');
    if (!token) return;

    try {
      const response = await fetch('http://localhost:5000/api/my-applications', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        const applications = data.applications || [];
        
        setStats({
          total: applications.length,
          reviewing: applications.filter(a => a.status === 'reviewing').length,
          shortlisted: applications.filter(a => a.status === 'shortlisted').length,
          saved: 0 // TODO: Implement saved jobs count
        });
      }
    } catch (err) {
      console.error('Error fetching stats:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 style={s.pageTitle}>Welcome back, {user.firstName}! 👋</h1>
      
      <div style={s.statsGrid}>
        <div style={{ ...s.statCard, borderTopColor: '#17a2b8' }}>
          <div style={{ fontSize: '36px', fontWeight: 800, color: '#17a2b8' }}>
            {loading ? '...' : stats.total}
          </div>
          <div style={{ fontSize: '14px', color: '#6c757d', marginTop: '8px' }}>Applications Submitted</div>
        </div>
        <div style={{ ...s.statCard, borderTopColor: '#ffc107' }}>
          <div style={{ fontSize: '36px', fontWeight: 800, color: '#ffc107' }}>
            {loading ? '...' : stats.reviewing}
          </div>
          <div style={{ fontSize: '14px', color: '#6c757d', marginTop: '8px' }}>Under Review</div>
        </div>
        <div style={{ ...s.statCard, borderTopColor: '#28a745' }}>
          <div style={{ fontSize: '36px', fontWeight: 800, color: '#28a745' }}>
            {loading ? '...' : stats.shortlisted}
          </div>
          <div style={{ fontSize: '14px', color: '#6c757d', marginTop: '8px' }}>Shortlisted</div>
        </div>
        <div style={{ ...s.statCard, borderTopColor: '#ff6b35' }}>
          <div style={{ fontSize: '36px', fontWeight: 800, color: '#ff6b35' }}>
            {loading ? '...' : stats.saved}
          </div>
          <div style={{ fontSize: '14px', color: '#6c757d', marginTop: '8px' }}>Saved Jobs</div>
        </div>
      </div>

      <div style={{ marginTop: '30px' }}>
        <h2 style={{ fontSize: '20px', color: '#1a2f4d', marginBottom: '15px' }}>Quick Actions</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
          <div onClick={() => setView('jobs')} style={s.actionCard}>
            <div style={{ fontSize: '32px', marginBottom: '10px' }}>🔍</div>
            <div style={{ fontWeight: 600, color: '#1a2f4d' }}>Browse Jobs</div>
            <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '5px' }}>Find construction opportunities</div>
          </div>
          <div onClick={() => setView('profile')} style={s.actionCard}>
            <div style={{ fontSize: '32px', marginBottom: '10px' }}>📄</div>
            <div style={{ fontWeight: 600, color: '#1a2f4d' }}>Upload CV</div>
            <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '5px' }}>Update your resume</div>
          </div>
          <div onClick={() => setView('profile')} style={s.actionCard}>
            <div style={{ fontSize: '32px', marginBottom: '10px' }}>👤</div>
            <div style={{ fontWeight: 600, color: '#1a2f4d' }}>Edit Profile</div>
            <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '5px' }}>Update your information</div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: '30px', padding: '20px', background: '#e7f3ff', borderRadius: '8px', borderLeft: '4px solid #17a2b8' }}>
        <h3 style={{ margin: '0 0 10px', color: '#1a2f4d', fontSize: '16px' }}>💡 Tip: Complete Your Profile</h3>
        <p style={{ margin: 0, color: '#6c757d', fontSize: '14px', lineHeight: 1.6 }}>
          Employers are looking for candidates with complete profiles! Add your CV, skills, and experience to increase your chances of getting hired.
        </p>
      </div>
    </div>
  );
}

// ============================== APPLICATIONS VIEW ==============================
function ApplicationsView({ user }) {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [expandedAppId, setExpandedAppId] = useState(null);
  const [expandedJobDetails, setExpandedJobDetails] = useState({});

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    const token = localStorage.getItem('candidateToken');
    if (!token) return;

    try {
      const response = await fetch('http://localhost:5000/api/my-applications', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setApplications(data.applications || []);
      } else {
        setError('Failed to load applications');
      }
    } catch (err) {
      console.error('Error fetching applications:', err);
      setError('Failed to load applications');
    } finally {
      setLoading(false);
    }
  };

  const toggleApplicationDetails = async (app) => {
    if (expandedAppId === app.id) {
      // Collapse if already expanded
      setExpandedAppId(null);
      return;
    }

    // Expand and fetch full job details
    setExpandedAppId(app.id);
    
    if (!expandedJobDetails[app.jobId]) {
      try {
        const response = await fetch(`http://localhost:5000/api/jobs/${app.jobId}`);
        if (response.ok) {
          const data = await response.json();
          setExpandedJobDetails({
            ...expandedJobDetails,
            [app.jobId]: data.job || data
          });
        }
      } catch (err) {
        console.error('Error fetching job details:', err);
      }
    }
  };

  const getStatusBadge = (status) => {
    const statusStyles = {
      submitted: { background: '#e3f2fd', color: '#1976d2' },
      reviewing: { background: '#fff3e0', color: '#f57c00' },
      shortlisted: { background: '#e8f5e9', color: '#388e3c' },
      rejected: { background: '#ffebee', color: '#d32f2f' }
    };

    const style = statusStyles[status] || statusStyles.submitted;

    return (
      <span style={{
        ...style,
        padding: '4px 12px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 600,
        textTransform: 'capitalize'
      }}>
        {status}
      </span>
    );
  };

  if (loading) {
    return (
      <div>
        <h1 style={s.pageTitle}>My Applications</h1>
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#6c757d' }}>
          <div style={{ fontSize: '32px', marginBottom: '10px' }}>⏳</div>
          <p>Loading applications...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h1 style={s.pageTitle}>My Applications</h1>
        <div style={s.flash}>{error}</div>
      </div>
    );
  }

  if (applications.length === 0) {
    return (
      <div>
        <h1 style={s.pageTitle}>My Applications</h1>
        
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#6c757d' }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>📋</div>
          <h3 style={{ fontSize: '20px', color: '#1a2f4d', marginBottom: '10px' }}>No Applications Yet</h3>
          <p style={{ fontSize: '14px', marginBottom: '20px' }}>
            You haven't applied to any jobs yet. Start browsing available positions!
          </p>
          <a href="/" style={s.primaryBtn}>Browse Jobs</a>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 style={s.pageTitle}>My Applications</h1>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        {applications.map(app => {
          const isExpanded = expandedAppId === app.id;
          const jobDetails = expandedJobDetails[app.jobId];
          
          return (
            <div key={app.id} style={{
              background: '#fff',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start'
              }}>
                <div style={{ flex: 1 }}>
                  <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#1a2f4d', marginBottom: '8px' }}>
                    {app.jobTitle}
                  </h3>
                  <div style={{ display: 'flex', gap: '20px', fontSize: '14px', color: '#6c757d', marginBottom: '10px' }}>
                    <span>📍 {app.jobLocation}</span>
                    <span>💼 {app.jobType}</span>
                    {app.jobSalary && <span>💰 {app.jobSalary}</span>}
                  </div>
                  <div style={{ fontSize: '13px', color: '#6c757d' }}>
                    Applied: {new Date(app.submittedAt).toLocaleDateString('en-GB', { 
                      day: 'numeric', 
                      month: 'short', 
                      year: 'numeric' 
                    })}
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'flex-end' }}>
                  {getStatusBadge(app.status)}
                  <button 
                    onClick={() => toggleApplicationDetails(app)}
                    style={{
                      fontSize: '13px',
                      color: '#ff6b35',
                      background: 'none',
                      border: 'none',
                      fontWeight: 600,
                      cursor: 'pointer',
                      padding: 0
                    }}
                  >
                    {isExpanded ? 'Hide Details ↑' : 'View Details →'}
                  </button>
                </div>
              </div>

              {/* Expanded Details Section */}
              {isExpanded && (
                <div style={{
                  marginTop: '20px',
                  paddingTop: '20px',
                  borderTop: '1px solid #e9ecef'
                }}>
                  {/* Job Description */}
                  {jobDetails && (
                    <div style={{ marginBottom: '25px' }}>
                      <h4 style={{ fontSize: '16px', fontWeight: 700, color: '#1a2f4d', marginBottom: '10px' }}>
                        Job Description
                      </h4>
                      <div style={{ 
                        fontSize: '14px', 
                        color: '#495057', 
                        lineHeight: 1.6,
                        padding: '15px',
                        background: '#f8f9fa',
                        borderRadius: '6px',
                        whiteSpace: 'pre-wrap'
                      }}>
                        {jobDetails.description || 'No description available'}
                      </div>
                      {jobDetails.requirements && (
                        <div style={{ marginTop: '15px' }}>
                          <h5 style={{ fontSize: '14px', fontWeight: 600, color: '#1a2f4d', marginBottom: '8px' }}>
                            Requirements:
                          </h5>
                          <div style={{ 
                            fontSize: '14px', 
                            color: '#495057', 
                            lineHeight: 1.6,
                            padding: '15px',
                            background: '#f8f9fa',
                            borderRadius: '6px',
                            whiteSpace: 'pre-wrap'
                          }}>
                            {jobDetails.requirements}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Cover Letter */}
                  {app.coverLetter && (
                    <div style={{ marginBottom: '25px' }}>
                      <h4 style={{ fontSize: '16px', fontWeight: 700, color: '#1a2f4d', marginBottom: '10px' }}>
                        Your Cover Letter
                      </h4>
                      <div style={{ 
                        fontSize: '14px', 
                        color: '#495057', 
                        lineHeight: 1.6,
                        padding: '15px',
                        background: '#e7f3ff',
                        borderRadius: '6px',
                        border: '1px solid #b3d9ff',
                        whiteSpace: 'pre-wrap'
                      }}>
                        {app.coverLetter}
                      </div>
                    </div>
                  )}

                  {/* CV/Resume */}
                  {app.resumeFilePath && (
                    <div>
                      <h4 style={{ fontSize: '16px', fontWeight: 700, color: '#1a2f4d', marginBottom: '10px' }}>
                        Your CV/Resume
                      </h4>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '15px',
                        background: '#f8f9fa',
                        borderRadius: '6px',
                        border: '1px solid #dee2e6'
                      }}>
                        <span style={{ fontSize: '24px' }}>📄</span>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: '14px', fontWeight: 600, color: '#1a2f4d' }}>
                            {app.resumeFilePath.split('/').pop().split('_').slice(2).join('_') || 'Resume'}
                          </div>
                          <div style={{ fontSize: '12px', color: '#6c757d' }}>
                            Submitted with application
                          </div>
                        </div>
                        <a
                          href={`http://localhost:5000/uploads/resumes/${app.resumeFilePath}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            padding: '8px 16px',
                            background: '#ff6b35',
                            color: '#fff',
                            borderRadius: '6px',
                            textDecoration: 'none',
                            fontSize: '13px',
                            fontWeight: 600
                          }}
                        >
                          Download
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ============================== SAVED JOBS VIEW ==============================
function SavedJobsView({ user }) {
  const [savedJobs, setSavedJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchSavedJobs();
  }, []);

  const fetchSavedJobs = async () => {
    const token = localStorage.getItem('candidateToken');
    if (!token) return;

    try {
      const response = await fetch('/api/saved-jobs', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        const data = await response.json();
        setSavedJobs(data.data || []);
      } else {
        setError('Failed to load saved jobs');
      }
    } catch (err) {
      console.error('Error fetching saved jobs:', err);
      setError('Failed to load saved jobs');
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveSavedJob = async (jobId) => {
    const token = localStorage.getItem('candidateToken');
    try {
      const response = await fetch(`/api/saved-jobs/${jobId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        setSavedJobs(savedJobs.filter(job => job.id !== jobId));
      }
    } catch (err) {
      console.error('Error removing saved job:', err);
    }
  };

  if (loading) {
    return (
      <div>
        <h1 style={s.pageTitle}>Saved Jobs</h1>
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#6c757d' }}>
          <div style={{ fontSize: '32px', marginBottom: '10px' }}>⏳</div>
          <p>Loading saved jobs...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h1 style={s.pageTitle}>Saved Jobs</h1>
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#d33' }}>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (savedJobs.length === 0) {
    return (
      <div>
        <h1 style={s.pageTitle}>Saved Jobs</h1>
        
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#6c757d' }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>💾</div>
          <h3 style={{ fontSize: '20px', color: '#1a2f4d', marginBottom: '10px' }}>No Saved Jobs</h3>
          <p style={{ fontSize: '14px', marginBottom: '20px' }}>
            Save jobs you're interested in to apply later!
          </p>
          <button onClick={() => window.location.hash = '#jobs'} style={s.primaryBtn}>Browse Jobs</button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 style={s.pageTitle}>Saved Jobs</h1>
      <p style={{ fontSize: '14px', color: '#6c757d', marginBottom: '20px' }}>
        {savedJobs.length} {savedJobs.length === 1 ? 'job' : 'jobs'} saved
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        {savedJobs.map(job => (
          <div key={job.id} style={{
            background: '#fff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            border: '1px solid #e9ecef',
            transition: 'all 0.2s'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#1a2f4d', marginBottom: '8px' }}>
                  {job.title}
                </h3>
                <div style={{ display: 'flex', gap: '15px', fontSize: '13px', color: '#6c757d', marginBottom: '10px' }}>
                  <span>📍 {job.location}</span>
                  {job.employmentType && <span>💼 {job.employmentType}</span>}
                  {job.salary && <span>💰 {job.salary}</span>}
                </div>
                {job.description && (
                  <p style={{ fontSize: '14px', color: '#495057', margin: '10px 0', lineHeight: 1.6 }}>
                    {job.description.substring(0, 150)}...
                  </p>
                )}
                <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '10px' }}>
                  Saved {new Date(job.savedAt).toLocaleDateString('en-GB')}
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginLeft: '20px' }}>
                <a
                  href={`/jobs/${job.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    padding: '8px 20px',
                    background: '#ff6b35',
                    color: '#fff',
                    textAlign: 'center',
                    borderRadius: '6px',
                    textDecoration: 'none',
                    fontSize: '14px',
                    fontWeight: 600,
                    whiteSpace: 'nowrap'
                  }}
                >
                  View Job
                </a>
                <button
                  onClick={() => handleRemoveSavedJob(job.id)}
                  style={{
                    padding: '8px 20px',
                    background: 'transparent',
                    color: '#dc3545',
                    border: '1px solid #dc3545',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ============================== PROFILE VIEW ==============================
function ProfileView({ user }) {
  const [formData, setFormData] = useState({
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    email: user.email || '',
    phone: user.phone || '',
  });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [uploading, setUploading] = useState(false);
  const [cvFile, setCvFile] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        setError('File size must be less than 5MB');
        return;
      }
      setCvFile(file);
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setUploading(true);

    try {
      const token = localStorage.getItem('candidateToken');
      const formDataToSend = new FormData();
      formDataToSend.append('firstName', formData.firstName);
      formDataToSend.append('lastName', formData.lastName);
      formDataToSend.append('phone', formData.phone);
      if (cvFile) {
        formDataToSend.append('cv', cvFile);
      }

      const response = await fetch('/api/candidate/profile', {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formDataToSend
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Failed to update profile');
      }

      const data = await response.json();
      setMessage('Profile updated successfully!');
      
      // Update localStorage
      const updatedUser = { ...user, ...data.user };
      localStorage.setItem('candidateUser', JSON.stringify(updatedUser));
      
      if (cvFile) {
        setCvFile(null);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <h1 style={s.pageTitle}>My Profile</h1>
      
      <div style={{ maxWidth: '600px' }}>
        {message && <div style={{ ...s.flash, background: '#d4edda', color: '#155724', border: '1px solid #c3e6cb' }}>{message}</div>}
        {error && <div style={s.flash}>{error}</div>}

        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.formGrid}>
            <div style={s.formGroup}>
              <label style={s.label}>First Name *</label>
              <input name="firstName" value={formData.firstName} onChange={handleChange} style={s.input} required />
            </div>
            <div style={s.formGroup}>
              <label style={s.label}>Last Name *</label>
              <input name="lastName" value={formData.lastName} onChange={handleChange} style={s.input} required />
            </div>
          </div>

          <div style={s.formGroup}>
            <label style={s.label}>Email Address *</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} style={s.input} disabled />
            <small style={{ fontSize: '12px', color: '#6c757d' }}>Email cannot be changed</small>
          </div>

          <div style={s.formGroup}>
            <label style={s.label}>Phone Number</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} style={s.input} />
          </div>

          <div style={s.formGroup}>
            <label style={s.label}>Default CV/Resume</label>
            <label htmlFor="cv-upload" style={{ padding: '20px', border: '2px dashed #dee2e6', borderRadius: '6px', textAlign: 'center', cursor: 'pointer', display: 'block' }}>
              <div style={{ fontSize: '32px', marginBottom: '10px' }}>📄</div>
              <p style={{ margin: '0 0 8px', color: '#6c757d', fontSize: '14px' }}>
                {cvFile ? cvFile.name : (user.defaultResume ? 'Change CV (PDF or Word)' : 'Upload your CV (PDF or Word)')}
              </p>
              <p style={{ margin: 0, color: '#6c757d', fontSize: '12px' }}>Max 5MB</p>
            </label>
            <input
              id="cv-upload"
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
            {user.defaultResume && !cvFile && (
              <small style={{ fontSize: '12px', color: '#28a745' }}>✓ Current CV uploaded</small>
            )}
          </div>

          <button type="submit" disabled={uploading} style={{ ...s.primaryBtn, opacity: uploading ? 0.6 : 1 }}>
            {uploading ? 'Saving...' : 'Save Changes'}
          </button>
        </form>
      </div>
    </div>
  );
}

// ============================== JOBS VIEW ==============================
function JobsView({ user }) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [applyingTo, setApplyingTo] = useState(null);
  const [applicationData, setApplicationData] = useState({ coverLetter: '', cv: null });
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [appliedJobIds, setAppliedJobIds] = useState(new Set());
  const [savedJobIds, setSavedJobIds] = useState(new Set());
  const [filters, setFilters] = useState({
    search: '',
    location: '',
    type: '',
    salary: ''
  });

  useEffect(() => {
    fetchJobsAndApplications();
  }, []);

  const fetchJobsAndApplications = async () => {
    try {
      const token = localStorage.getItem('candidateToken');
      
      // Fetch jobs
      const jobsResponse = await fetch('/api/jobs');
      if (jobsResponse.ok) {
        const jobsData = await jobsResponse.json();
        setJobs(jobsData.jobs || []);
      }

      // Fetch user's applications and saved jobs
      if (token) {
        const appsResponse = await fetch('/api/my-applications', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (appsResponse.ok) {
          const appsData = await appsResponse.json();
          const appliedIds = new Set(appsData.applications.map(app => app.jobId));
          setAppliedJobIds(appliedIds);
        }

        const savedResponse = await fetch('/api/saved-jobs', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (savedResponse.ok) {
          const savedData = await savedResponse.json();
          const savedIds = new Set(savedData.data.map(job => job.id));
          setSavedJobIds(savedIds);
        }
      }
    } catch (err) {
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleApplyClick = (jobId) => {
    setApplyingTo(jobId);
    setApplicationData({ coverLetter: '', cv: null });
    setMessage({ type: '', text: '' });
  };

  const handleCancelApply = () => {
    setApplyingTo(null);
    setApplicationData({ coverLetter: '', cv: null });
    setMessage({ type: '', text: '' });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 5 * 1024 * 1024) {
      setApplicationData({ ...applicationData, cv: file });
    } else {
      setMessage({ type: 'error', text: 'File must be less than 5MB' });
    }
  };

  const handleSubmitApplication = async (jobId) => {
    if (!applicationData.coverLetter.trim()) {
      setMessage({ type: 'error', text: 'Please write a cover letter' });
      return;
    }

    setSubmitting(true);
    setMessage({ type: '', text: '' });

    try {
      const token = localStorage.getItem('candidateToken');
      const formData = new FormData();
      formData.append('jobId', jobId);
      formData.append('coverLetter', applicationData.coverLetter);
      if (applicationData.cv) {
        formData.append('resume', applicationData.cv);
      }

      const response = await fetch('/api/applications', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Application failed');
      }

      setMessage({ type: 'success', text: 'Application submitted successfully!' });
      
      // Mark this job as applied
      setAppliedJobIds(prev => new Set([...prev, jobId]));
      
      setTimeout(() => {
        setApplyingTo(null);
        setApplicationData({ coverLetter: '', cv: null });
      }, 2000);
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
    } finally {
      setSubmitting(false);
    }
  };

  const handleSaveJob = async (jobId) => {
    try {
      const token = localStorage.getItem('candidateToken');
      const response = await fetch('/api/saved-jobs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ jobId })
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Failed to save job');
      }

      setMessage({ type: 'success', text: 'Job saved successfully!' });
      
      // Mark this job as saved
      setSavedJobIds(prev => new Set([...prev, jobId]));
      
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
    }
  };

  const filteredJobs = jobs.filter(job => {
    const matchesSearch = !filters.search || 
      job.title.toLowerCase().includes(filters.search.toLowerCase()) ||
      job.description.toLowerCase().includes(filters.search.toLowerCase());
    const matchesLocation = !filters.location || 
      job.location.toLowerCase().includes(filters.location.toLowerCase());
    const matchesType = !filters.type || 
      (job.employment_type && job.employment_type === filters.type) ||
      (job.jobType && job.jobType === filters.type);
    
    return matchesSearch && matchesLocation && matchesType;
  });

  return (
    <div>
      <h1 style={s.pageTitle}>Browse Jobs</h1>
      
      {/* Filters */}
      <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', marginBottom: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
          <input
            type="text"
            name="search"
            placeholder="Search jobs..."
            value={filters.search}
            onChange={handleFilterChange}
            style={s.input}
          />
          <input
            type="text"
            name="location"
            placeholder="Location..."
            value={filters.location}
            onChange={handleFilterChange}
            style={s.input}
          />
          <select name="type" value={filters.type} onChange={handleFilterChange} style={s.input}>
            <option value="">All Types</option>
            <option value="permanent">Permanent</option>
            <option value="contract">Contract</option>
            <option value="temporary">Temporary</option>
          </select>
          <button 
            onClick={() => setFilters({ search: '', location: '', type: '', salary: '' })}
            style={{ ...s.primaryBtn, background: '#6c757d' }}
          >
            Clear Filters
          </button>
        </div>
        <div style={{ marginTop: '10px', fontSize: '13px', color: '#6c757d' }}>
          {filteredJobs.length} {filteredJobs.length === 1 ? 'job' : 'jobs'} found
        </div>
      </div>

      {/* Jobs Listing */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#6c757d' }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
          <p>Loading jobs...</p>
        </div>
      ) : filteredJobs.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#6c757d' }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>🔍</div>
          <h3 style={{ fontSize: '20px', color: '#1a2f4d', marginBottom: '10px' }}>No Jobs Found</h3>
          <p style={{ fontSize: '14px', marginBottom: '20px' }}>
            {filters.search || filters.location || filters.type ? 
              'Try adjusting your filters' : 
              'Check back soon for new opportunities'}
          </p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {filteredJobs.map(job => (
            <div key={job.id} style={{
              background: '#fff',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              border: '1px solid #e9ecef',
              transition: 'all 0.2s',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
              e.currentTarget.style.borderColor = '#ff6b35';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
              e.currentTarget.style.borderColor = '#e9ecef';
            }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '12px' }}>
                <div>
                  <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#1a2f4d', margin: '0 0 8px' }}>
                    {job.title}
                  </h3>
                  <div style={{ display: 'flex', gap: '15px', fontSize: '13px', color: '#6c757d' }}>
                    <span>📍 {job.location}</span>
                    <span>💼 {job.employment_type || job.jobType || 'N/A'}</span>
                    {job.salary && <span>💰 {job.salary}</span>}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  {appliedJobIds.has(job.id) && (
                    <span style={{
                      padding: '4px 12px',
                      background: '#d4edda',
                      color: '#155724',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: 600
                    }}>
                      ✓ Applied
                    </span>
                  )}
                  {savedJobIds.has(job.id) && (
                    <span style={{
                      padding: '4px 12px',
                      background: '#fff3cd',
                      color: '#856404',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: 600
                    }}>
                      💾 Saved
                    </span>
                  )}
                  <span style={{
                    padding: '4px 12px',
                    background: '#e7f3ff',
                    color: '#17a2b8',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: 600
                  }}>
                    {job.status === 'active' ? 'Active' : 'Closed'}
                  </span>
                </div>
              </div>
              
              <p style={{ fontSize: '14px', color: '#495057', margin: '0 0 15px', lineHeight: 1.6 }}>
                {job.description?.substring(0, 200) || job.jobDescription?.substring(0, 200) || 'No description available'}...
              </p>
              
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!appliedJobIds.has(job.id)) {
                      handleApplyClick(job.id);
                    }
                  }}
                  disabled={appliedJobIds.has(job.id)}
                  style={{
                    padding: '8px 20px',
                    background: appliedJobIds.has(job.id) ? '#95a5a6' : '#ff6b35',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: appliedJobIds.has(job.id) ? 'not-allowed' : 'pointer',
                    opacity: appliedJobIds.has(job.id) ? 0.7 : 1
                  }}
                  onMouseEnter={(e) => {
                    if (!appliedJobIds.has(job.id)) {
                      e.currentTarget.style.background = '#ff5220';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!appliedJobIds.has(job.id)) {
                      e.currentTarget.style.background = '#ff6b35';
                    }
                  }}
                >
                  {appliedJobIds.has(job.id) ? 'Already Applied' : 'Apply Now'}
                </button>
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!savedJobIds.has(job.id)) {
                      handleSaveJob(job.id);
                    }
                  }}
                  disabled={savedJobIds.has(job.id)}
                  style={{
                    padding: '8px 20px',
                    background: savedJobIds.has(job.id) ? '#fff3cd' : 'transparent',
                    color: savedJobIds.has(job.id) ? '#856404' : '#6c757d',
                    border: savedJobIds.has(job.id) ? '1px solid #ffeaa7' : '1px solid #dee2e6',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: savedJobIds.has(job.id) ? 'default' : 'pointer',
                    opacity: savedJobIds.has(job.id) ? 0.9 : 1
                  }}
                  onMouseEnter={(e) => {
                    if (!savedJobIds.has(job.id)) {
                      e.currentTarget.style.background = '#f8f9fa';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!savedJobIds.has(job.id)) {
                      e.currentTarget.style.background = 'transparent';
                    }
                  }}
                >
                  {savedJobIds.has(job.id) ? '💾 Saved' : '💾 Save'}
                </button>
                {job.createdAt && (
                  <span style={{ fontSize: '12px', color: '#6c757d', marginLeft: 'auto' }}>
                    Posted {new Date(job.createdAt).toLocaleDateString()}
                  </span>
                )}
              </div>

              {/* Inline Application Form */}
              {applyingTo === job.id && (
                <div style={{
                  marginTop: '20px',
                  padding: '20px',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  border: '1px solid #dee2e6'
                }}>
                  <h4 style={{ margin: '0 0 15px', fontSize: '16px', fontWeight: 700, color: '#1a2f4d' }}>
                    Apply for {job.title}
                  </h4>

                  {message.text && message.type && (
                    <div style={{
                      padding: '12px',
                      marginBottom: '15px',
                      borderRadius: '6px',
                      background: message.type === 'success' ? '#d4edda' : '#f8d7da',
                      color: message.type === 'success' ? '#155724' : '#721c24',
                      border: `1px solid ${message.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                      fontSize: '14px'
                    }}>
                      {message.text}
                    </div>
                  )}

                  <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '6px', fontSize: '14px', fontWeight: 600, color: '#495057' }}>
                      Cover Letter <span style={{ color: '#dc3545' }}>*</span>
                    </label>
                    <textarea
                      rows="6"
                      placeholder="Explain why you're the perfect fit for this role..."
                      value={applicationData.coverLetter}
                      onChange={(e) => setApplicationData({...applicationData, coverLetter: e.target.value})}
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #ced4da',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'inherit',
                        resize: 'vertical'
                      }}
                      required
                    />
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '6px', fontSize: '14px', fontWeight: 600, color: '#495057' }}>
                      CV / Resume
                    </label>
                    {user.defaultResume && (
                      <div style={{ marginBottom: '8px', padding: '8px 12px', background: '#e7f3ff', borderRadius: '6px', fontSize: '13px', color: '#17a2b8' }}>
                        ✓ We'll use your profile CV
                      </div>
                    )}
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={handleFileChange}
                      style={{
                        display: 'block',
                        width: '100%',
                        padding: '8px',
                        fontSize: '13px',
                        border: '1px solid #ced4da',
                        borderRadius: '6px'
                      }}
                    />
                    <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '4px' }}>
                      Or upload a different CV for this application (PDF, DOC, DOCX - max 5MB)
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      onClick={() => handleSubmitApplication(job.id)}
                      disabled={submitting || !applicationData.coverLetter.trim()}
                      style={{
                        padding: '10px 24px',
                        background: submitting || !applicationData.coverLetter.trim() ? '#95a5a6' : '#28a745',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: submitting || !applicationData.coverLetter.trim() ? 'not-allowed' : 'pointer'
                      }}
                    >
                      {submitting ? 'Submitting...' : 'Submit Application'}
                    </button>
                    <button
                      onClick={handleCancelApply}
                      disabled={submitting}
                      style={{
                        padding: '10px 24px',
                        background: 'transparent',
                        color: '#6c757d',
                        border: '1px solid #ced4da',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: submitting ? 'not-allowed' : 'pointer'
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ============================== STYLES ==============================
const s = {
  layout: { position: 'relative', minHeight: '100vh', fontFamily: "'Open Sans', sans-serif", width: '100vw', maxWidth: '100vw', overflow: 'hidden' },
  sidebar: {
    width: '260px', background: '#1a2f4d', color: '#fff', display: 'flex', flexDirection: 'column',
    position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 1000,
  },
  sidebarHeader: {
    padding: '20px', display: 'flex', alignItems: 'center', gap: '12px',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
  },
  logo: {
    width: '40px', height: '40px', background: '#ff6b35', borderRadius: '8px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '20px', fontWeight: 800, fontFamily: 'Montserrat, sans-serif', flexShrink: 0,
  },
  brandName: { fontWeight: 700, fontSize: '16px', fontFamily: 'Montserrat, sans-serif' },
  brandSub: { fontSize: '11px', color: '#94a3b8', letterSpacing: '1px' },
  nav: { flex: 1, padding: '15px 10px', display: 'flex', flexDirection: 'column', gap: '4px' },
  navBtn: {
    background: 'transparent', border: 'none', color: '#cbd5e1', padding: '12px 15px',
    borderRadius: '8px', textAlign: 'left', cursor: 'pointer', fontSize: '14px', fontWeight: 500,
    transition: 'all 0.2s',
  },
  navBtnActive: { background: 'rgba(255,107,53,0.2)', color: '#ff6b35' },
  sidebarFooter: { padding: '15px 20px', borderTop: '1px solid rgba(255,255,255,0.1)' },
  logoutBtn: {
    background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', padding: '8px 16px',
    borderRadius: '6px', cursor: 'pointer', fontSize: '13px', width: '100%',
  },
  main: { marginLeft: '260px', padding: '30px', background: '#f8f9fa', minHeight: '100vh', width: 'calc(100vw - 260px)', boxSizing: 'border-box' },
  pageTitle: { fontSize: '24px', fontWeight: 700, color: '#1a2f4d', margin: '0 0 20px', fontFamily: 'Montserrat, sans-serif' },
  flash: { padding: '12px 20px', background: '#fee', color: '#d33', borderRadius: '6px', marginBottom: '20px', border: '1px solid #fcc' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px' },
  statCard: { background: '#fff', padding: '20px', borderRadius: '8px', borderTop: '4px solid', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' },
  actionCard: {
    background: '#fff', padding: '20px', borderRadius: '8px', textAlign: 'center', cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)', transition: 'transform 0.2s, box-shadow 0.2s',
    textDecoration: 'none', display: 'block',
  },
  primaryBtn: {
    display: 'inline-block', padding: '12px 24px', background: '#ff6b35', color: '#fff',
    border: 'none', borderRadius: '6px', fontSize: '14px', fontWeight: 600, cursor: 'pointer',
    textDecoration: 'none', transition: 'background 0.2s',
  },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' },
  formGroup: { display: 'flex', flexDirection: 'column', gap: '8px' },
  label: { fontSize: '14px', fontWeight: 600, color: '#1a2f4d' },
  input: {
    padding: '10px 14px', border: '1px solid #dee2e6', borderRadius: '6px',
    fontSize: '14px', outline: 'none', transition: 'border-color 0.2s',
  },
};
